var _path, _path2, _path3, _path4, _path5, _mask, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTip = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3163 4.59184V0",
    stroke: "#7B7DFC",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2857 6.46079L22.5326 3.21387",
    stroke: "#7B7DFC",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92038 6.46079L3.67346 3.21387",
    stroke: "#7B7DFC",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.59184 11.4795L0 11.4795",
    stroke: "#7B7DFC",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6327 11.4795L22.0408 11.4795",
    stroke: "#7B7DFC",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-1_401_1308",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5306 18.9498C18.7153 17.795 20.2041 15.4996 20.2041 12.8565C20.2041 9.0525 17.1203 5.96875 13.3163 5.96875C9.51234 5.96875 6.42859 9.0525 6.42859 12.8565C6.42859 15.4996 7.91735 17.795 10.1021 18.9498V22.4994H16.5306V18.9498Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5306 18.9498L15.8296 17.6237L15.0306 18.0461V18.9498H16.5306ZM10.1021 18.9498H11.6021V18.0461L10.8031 17.6237L10.1021 18.9498ZM10.1021 22.4994H8.60206V23.9994H10.1021V22.4994ZM16.5306 22.4994V23.9994H18.0306V22.4994H16.5306ZM18.7041 12.8565C18.7041 14.9219 17.5424 16.7184 15.8296 17.6237L17.2316 20.276C19.8883 18.8716 21.7041 16.0773 21.7041 12.8565H18.7041ZM13.3163 7.46875C16.2919 7.46875 18.7041 9.88093 18.7041 12.8565H21.7041C21.7041 8.22408 17.9488 4.46875 13.3163 4.46875V7.46875ZM7.92859 12.8565C7.92859 9.88093 10.3408 7.46875 13.3163 7.46875V4.46875C8.68391 4.46875 4.92859 8.22408 4.92859 12.8565H7.92859ZM10.8031 17.6237C9.09033 16.7184 7.92859 14.9219 7.92859 12.8565H4.92859C4.92859 16.0773 6.74438 18.8716 9.40106 20.276L10.8031 17.6237ZM11.6021 22.4994V18.9498H8.60206V22.4994H11.6021ZM16.5306 20.9994H10.1021V23.9994H16.5306V20.9994ZM15.0306 18.9498L15.0306 22.4994H18.0306V18.9498H15.0306Z",
    fill: "#7B7DFC",
    mask: "url(#path-6-inside-1_401_1308)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4796 19.7451H15.1531",
    stroke: "#7B7DFC",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tip.6f5cf2fb4339fba8dcdd3a06c1494b89.svg";